export const YESNOOPTIONS = [
  { id: false, name: 'No' },
  { id: true, name: 'Yes' },
];

export const DISPLAYOPTIONS = [{ id: 1, name: 'List' }];

export const SORTOPTIONS = [
  { id: true, name: 'Ascending' },
  { id: false, name: 'Desceding' },
];
